import { GET_BILLING_LIST, GET_BILLING_REPORT_DATA } from '../actionTypes.js';
const defaultState = {
    billingList: [],
    billingReport:{}
}
export default (state=defaultState, action)=>{
    switch(action.type){
        case GET_BILLING_LIST:
            return {...state, billingList: action.payload||defaultState.billingReport}
        case GET_BILLING_REPORT_DATA:
                return {...state, billingReport: action.payload||defaultState.billingReport}
        default:
            return state;
    }
}